import { Button, type ButtonProps } from "@heroui/react";
import HintTooltip from "./HintTooltip";

import { useAuth } from "@/lib/auth-context";
import { canWrite, unauthorizedMessage, type WriteScope } from "@/lib/authorization";

/**
 * 権限（WriteScope）で有効／無効が切り替わるボタン。
 *
 * 権限が無い場合は disabled にし、理由を Tooltip で表示する。ボタンを消すのでは
 * なく無効化して理由を見せるのは、「機能が無い」のか「権限が足りない」のかを
 * 利用者が区別できるようにするため（ngtg_msc の AuthorizedButton と同じ方針）。
 *
 * **権限判定の最終的な境界は API 側**。これは UI の出し分けにすぎない。
 */
export default function AuthorizedButton({
  scope,
  children,
  ...props
}: ButtonProps & { scope: WriteScope }) {
  const { user } = useAuth();
  const allowed = canWrite(user, scope);

  const button = (
    <Button {...props} isDisabled={!allowed || props.isDisabled}>
      {children}
    </Button>
  );

  if (allowed) return button;
  return (
    <HintTooltip content={unauthorizedMessage(scope)}>
      {/* disabled な要素はイベントを発火しないため、Tooltip 用に包む。 */}
      <span className="inline-flex">{button}</span>
    </HintTooltip>
  );
}
